import React from "react";

const FAQ = () => {
  return (
    <>
      <div className="faq-page inner-page">
        <div className="container">
          <h1 className="policies-title">FAQ</h1>
          <div className="policies-date">
            Last updated on: 28th November 2024
          </div>
          <div className="admin-content-area">
            <dl className="default">
              <dt>
                <span className="counter-span"></span>What are the services
                offered by Photofind?
              </dt>
              <dd>
                For a Corporate or an organization, Photofind is a friendly
                digital photo album. Best of your photos can be uploaded to
                Photofind through a simple drag and drop process. The photos can
                be re-grouped into albums and re arranged based on your
                preferences.
                <br />
                For a Photo Studio or a Wedding/Event photographer, Photofind.in
                offers a simple and friendly CRM module to professionally manage
                the photo shoot assignments. It has features for the clients of
                the studio to quickly select the best photos required for the
                print and digital albums.
                <br />
                Finally the selected, edited photos are uploaded through the
                Photofind on to FPA (FamilyPhotosAlbum.com) which is a well
                designed Digital Album with many viewing and sharing options.
              </dd>

              <dt>
                <span className="counter-span"></span>Does Photofind seek access
                to the photo folder of my computer/mobile phone/portable
                devices?
              </dt>
              <dd>
                No. Photofind does not seek access to your phone/computer and
                its storage folders, essentially because Photofind is not a mass
                storage solution. It gives you a personal on-line platform for
                convenient and organised display of your selected photographic
                memories.
              </dd>

              <dt>
                <span className="counter-span"></span>Does Photofind use
                cookies?
              </dt>
              <dd>
                No. Photofind respects your total privacy. Photofind does not
                use any cookies.
              </dd>

              <dt>
                <span className="counter-span"></span>Why is Photofind
                necessary? Why cannot we continue to store the photos in our
                computer/mobile phone/other personal devices?
              </dt>
              <dd>
                Photofind solutions and data base resides on fast cloud-based
                servers. This lets you to access your valuable photo-based
                memories from anywhere around the globe, while connected to the
                Internet. Even if you are away from your own devices, you can
                access your photos and documents. Even if your mobile
                phone/laptop computer is lost or misplaced, you do not lose
                access to your valuable photos.
              </dd>

              <dt>
                <span className="counter-span"></span>My photos are stored in
                iCloud and Google drives. So I do not lose them. So, what is so
                special about Photofind?
              </dt>
              <dd>
                Photofind is not a mass storage platform to dump your entire
                photo gallery. Rather, it is a premium selection of your
                photographic memories. Photofind’s strength is fast
                search/retrieval of your best cherished photographs along with a
                provision to share photographs to your loved ones, if you choose
                to. After logging in to FPA, a photo can be located at ease and
                the link can be shared with in a few seconds to your clients or
                loved ones.
              </dd>

              <dt>
                <span className="counter-span"></span>Is photo tagging possible
                on Photofind/FPA?
              </dt>
              <dd>
                Yes. You can add any text against a photo and can be later
                searched based on that text tag. Multiple tags can be added to a
                photo.
              </dd>

              <dt>
                <span className="counter-span"></span>Is location-based photo
                search possible on Photofind/FPA?
              </dt>
              <dd>
                If your location service was active while shooting the
                photograph, Photofind/FPA will capture the location details from
                the metadata of the photograph file and the photos can be
                searched out based on the location.
              </dd>

              <dt>
                <span className="counter-span"></span>Can I make subject-wise
                albums to organise my photos?
              </dt>
              <dd>
                Yes, of course. You can create multiple number of albums and
                organise them, subject-wise. Albums can be viewed as grids or in
                expanded mode/view. These preferences can be set in the
                preferences page. Albums can also be re-arranged in your order
                of preference. The photos in every album can also be re-arranged
                in the desired order, just like you re-arrange the application
                icons in a mobile phone.
              </dd>

              <dt>
                <span className="counter-span"></span>Can I hide an album along
                with its contents?
              </dt>
              <dd>
                Yes. In a family or corporate environment, if you want privacy
                of your photos, you can hide and un-hide an album at will. This
                feature will be particularly useful while making slide-shows
                which is another feature of Photofind/FPA
              </dd>

              <dt>
                <span className="counter-span"></span> How do I make a
                slide-show?
              </dt>
              <dd>
                There are two ways. If you want to make a quick slide-show, you
                can simply select a few photos from your general gallery or
                albums and click the slide show button. The Photofind/FPA takes
                a few seconds and the slideshow starts on a standard display
                mode. If you want to make an organised slide show, you can
                create a slide show for your clients or friends by carefully
                selecting the photos and setting your preferences of duration,
                display styles and music tracks.
              </dd>

              <dt>
                <span className="counter-span"></span>Does Photofind reduce the
                file size of my uploaded photo?
              </dt>
              <dd>
                Photofind tries to remove unused metadata and optimise the file
                sizes. This is for improving the performance of your album.
                However, the viewing quality standards shall be maintained.
              </dd>

              <dt>
                <span className="counter-span"></span>After uploading the photos
                to Photofind, can I delete the original files from my local
                storage devices?
              </dt>
              <dd>
                As already mentioned, Photofind is not a mass storage solution.
                We request you to preserve your valuable originals. Photofind
                optimises the file sizes for web-based viewing. Hence, it cannot
                be considered as a platform to store your photographs in full
                resolution.
              </dd>

              <dt>
                <span className="counter-span"></span>Can you make Photofind’s
                value proposition more clear ?
              </dt>
              <dd>
                <p>Read through the following scenarios:</p>
                <ol className="lower-alpha">
                  <li>
                    You met your friend who is a famous wild life photographer.
                    You ask him to showcase his best photographs from his
                    collection. Its most likely that he will have to search
                    through his hard drives/archives and spend a lot of time to
                    make a selection. Even if he fetches some for you, he may
                    not be fully satisfied that he has shown you all his best
                    photographs. If he is a subscriber of FPA or Photofind
                    (FPA’s studio/professional front end), where he has his best
                    selection of photographs, then it takes only a few seconds
                    to retrieve & show to you his best photographs, accessible
                    from around the globe.
                  </li>
                  <li>
                    In Photofind, from the general gallery of photos, you can
                    mark your favourites. From the favourite folder, you can
                    ‘star’ the best selections. Those starred favourites appear
                    on your Profile Gallery and these can be re arranged based
                    on your liking. This becomes the portfolio of a professional
                    photographer. This portfolio can be shared among
                    friends/family or for business purposes. So the combination
                    of FPA and Photofind gives a lot of professional business
                    possibilities. Professionals like Architects and Creative
                    Artists can showcase their work in a similar manner.
                  </li>
                  <li>
                    There is a default album called “Documents” which can store
                    the .jpeg / .png or pdf copies of your Passport, VISA,
                    Security IDs and other important documents. Even if you
                    misplace your mobile phone or Laptop, you can log in to
                    FPA/Photofind and retrieve and share the documents within a
                    few seconds. Companies/Corporates can use this folder to
                    store their important official documents for quick
                    retrieval.
                  </li>
                  <li>
                    For the clients of Studio/Photographers, Photofind along
                    with FPA gives a feature to build their Family Tree. At
                    first, upload the portraits or faces into the standard album
                    called FACES/PORTRAITS. Build the family tree and drag drop
                    the photos from this folder to make the family tree. You can
                    even place the photo and details of your pets in the family
                    tree. Sharing the family tree with family and friends will
                    be very interesting. The family tree can be saved as a pdf
                    which can be later expanded, viewed and printed.
                  </li>
                  <li>
                    For corporates, Photofind becomes a very useful platform for
                    storing the valuable photographs which can be easily
                    recalled for reviews, board meetings and when needed for
                    printing annual reports. Text based tagging enables easy
                    photo search.
                  </li>
                  <li>
                    Wedding photographers and Photo Studios can register on
                    Photofind.in and easily transact with their clients to make
                    quick selections of the photos from the bulk clicks. They
                    can record their project events, assign the staff by sharing
                    the data so that the events are covered in time.
                    Water-marked thumbnails of photographs can be shared with
                    the clients and the Photofind link helps the client to make
                    quick selections of the photos. This saves a lot of time and
                    results in better customer satisfaction. The finally
                    selected photos get uploaded on to Photofind and from there,
                    the end client can start viewing the album.
                  </li>
                </ol>
              </dd>

              <dt>
                <span className="counter-span"></span>Is photo editing possible
                on Photofind/FPA?
              </dt>
              <dd>
                Yes. A variety of photo editing tools are built-in to
                Photofind/FPA. Moreover, a variety of frames can be added in the
                photos placed under sub-albums.
              </dd>

              <dt>
                <span className="counter-span"></span>Will photos get
                accidentally erased/deleted in Photofind?
              </dt>
              <dd>
                A confirmation is always sought for before deleting a photo
                file. So, accidental erasure can be prevented. If you delete an
                album, a confirmation is asked whether to delete the contents
                also. Even after deletion of the photos, they remain in a
                recoverable bin for 24 hours.
              </dd>

              <dt>
                <span className="counter-span"></span>What happens if I forget
                to renew the subscription after the due date?
              </dt>
              <dd>
                Photofind/FPA will send subtle and polite reminder e-mails for
                the renewal of the subscription. The services will continue
                during the grace period of 15 days after which the photos will
                be seen only as low-resolution thumbnails. You can re-activate
                your account within a period of 3 months if you make the
                payment. After 3 months if the subscription is not renewed,
                Photofind/FPA will send a message and inform you that the
                account and the contents are getting deleted from the system.
              </dd>

              <dt>
                <span className="counter-span"></span>How many photos can be
                uploaded per Photofind account?
              </dt>
              <dd>
                A regular account will hold 1200 (one thousand two hundred)
                photographs. A corporate account can hold up to 3000 (Three
                thousand) photos. Again reminding you that Photofind is not a
                mass storage system. Photofind expects to hold your best
                selection of photos so that you can proudly showcase your albums
                to your friends, relatives and business contacts.
              </dd>
            </dl>
            <i>Photofind/FAQ/V 1.06 Dated 28th November 2024</i>
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQ;
